import useAppQuery from 'hooks/useAppQuery';
import API from 'services/API';
import useAppUser from '../../../hooks/useAppUser';
import { useHostQualityContext } from '../useHostQualityContext';
import { AirbnbAnalyticsKeyMetricsResponse } from './types/HostQuality.types';

const useAirbnbKeyMetrics = () => {
  const { agencyUid } = useAppUser();
  const { hostQualityFilter } = useHostQualityContext();

  const { data: keyMetrics, isLoading: isKeyMetricsLoading } = useAppQuery(
    ['getKeyMetrics', hostQualityFilter, agencyUid],
    async () => {
      const response = await API.post<AirbnbAnalyticsKeyMetricsResponse>(
        `/api/internal/airbnb/analytics/key-metrics`,
        {
          propertyUids: hostQualityFilter?.propertyUid
            ? [hostQualityFilter.propertyUid]
            : [],
          ownerUids: hostQualityFilter?.ownerUid
            ? [hostQualityFilter.ownerUid]
            : [],
          locations: hostQualityFilter?.location
            ? [hostQualityFilter.location]
            : [],
          from: hostQualityFilter?.range.startDate.toISOString(),
          to: hostQualityFilter?.range.endDate.toISOString(),
        },
      );
      return response.data;
    },
    {
      enabled: agencyUid != null && !!hostQualityFilter,
    },
  );

  return {
    keyMetrics,
    isKeyMetricsLoading,
  };
};

export default useAirbnbKeyMetrics;
